module.exports = __webpack_public_path__ + "media/images/popover/illustration-5-3567ad2dfd850578b84c0853b084e7d3.png";